import { useResolution } from 'common/hooks'
import { CopyRight } from 'components/CopyRight'
import { Styled } from 'components/Styled'
import { Container, FlexWrapper } from 'components/Styled/Styled'

import { Component } from './components'
import { StyledFooter, StyledFooterBottom, StyledFooterMenu, StyledFooterTop } from './styled'

export const Footer = () => {


  return (
    <StyledFooter>
      <StyledFooterTop>
          <Component.BrandEntities />
          <StyledFooterMenu>
            <Component.Menu />
          </StyledFooterMenu>
          <Component.UpButton />
        </StyledFooterTop>
      <StyledFooterBottom>
          <Component.General/>
      </StyledFooterBottom>
    </StyledFooter>
  )
}
